/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationState } from './OrganizationState';
import {
    OrganizationStateFromJSON,
    OrganizationStateFromJSONTyped,
    OrganizationStateToJSON,
    OrganizationStateToJSONTyped,
} from './OrganizationState';

/**
 * 
 * @export
 * @interface CreateOrganizationState201Response
 */
export interface CreateOrganizationState201Response {
    /**
     * 
     */
    data?: OrganizationState;
}

/**
 * Check if a given object implements the CreateOrganizationState201Response interface.
 */
export function instanceOfCreateOrganizationState201Response(value: object): value is CreateOrganizationState201Response {
    return true;
}

export function CreateOrganizationState201ResponseFromJSON(json: any): CreateOrganizationState201Response {
    return CreateOrganizationState201ResponseFromJSONTyped(json, false);
}

export function CreateOrganizationState201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationState201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : OrganizationStateFromJSON(json['data']),
    };
}

export function CreateOrganizationState201ResponseToJSON(json: any): CreateOrganizationState201Response {
    return CreateOrganizationState201ResponseToJSONTyped(json, false);
}

export function CreateOrganizationState201ResponseToJSONTyped(value?: CreateOrganizationState201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': OrganizationStateToJSON(value['data']),
    };
}

